import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Edit as EditIcon } from "@mui/icons-material";
import {
  ConnectAccountManagement,
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { useStripeConnect } from "../../utils/useStripeConnect";
import { backend, backend2 } from "../../api";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles, InputLabel, TextField, Button } from "@material-ui/core";
import { Helmet } from "react-helmet";
import PageBanner from "../PageBanner";
const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
  },
  boxAccount: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    padding: theme.spacing(2),
  },
  boxHead: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  themeCard: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
  },
  tabContainer: {
    borderBottom: `1px solid ${theme.palette.divider}`, // Corrected line
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
  },
  formGroup: {
    marginBottom: theme.spacing(2),
  },
  selectMethod: {
    marginTop: theme.spacing(2),
  },
  currentMethod: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`, // Corrected line
    borderRadius: theme.shape.borderRadius,
    textAlign: "center",
    marginTop: theme.spacing(3),
  },
  saveButton: {
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5, 2),
  },
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
    border: `1px solid ${theme.palette.divider}`,
    fontSize: "0.875rem",
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  submitBtn: {
    color: theme.palette.secondary.light,
    backgroundColor: theme.palette.primary.main,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.secondary.dark,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    color: theme.palette.secondary.light,
  },
  selectDropdown: {
    padding: "10px",
    borderRadius: "2px",
    border: `1px solid ${theme.palette.divider}`,
    fontSize: "0.875rem",
    width: "100%",
    marginBottom: theme.spacing(2),
  },
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const AddNewPaymentMethod = ({ register, redirect }) => {
  const classes = useStyles();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const method = query.get("method");
  const stripeAccountId = query.get("stripeaccountid"); 
  const [eMoneyAccountNo, setEMoneyAccountNo] = useState("");
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [existingMethods, setExistingMethods] = useState({ methods: [] });
  const [isSaving, setIsSaving] = useState(false);
  const { currentUser } = useSelector((state) => state.auth);
  const [connectedAccountId, setConnectedAccountId] = useState(stripeAccountId || null);
  const [accountCreatePending, setAccountCreatePending] = useState(false);
  const [onboardingExited, setOnboardingExited] = useState(false);
  const [isVerified, setIsVerified] = useState(false);


  const history = useHistory();
  const dispatch = useDispatch();

  const stripeConnectInstance = useStripeConnect(connectedAccountId);

  const fetchPaymentMethods = async () => {
    try {
      const response = await backend.get(
        `/payment-method?user=${currentUser.author._id}`
      );
      const { paymentMethods } = response.data;

      if (paymentMethods && paymentMethods.methods.length > 0) {
        setExistingMethods(paymentMethods);

        if (paymentMethods.selectedPaymentType) {
          setSelectedPaymentType(paymentMethods.selectedPaymentType);
        }
      }
    } catch (error) {
      console.error("Error fetching payment methods:", error);
      toast.error("Failed to fetch payment methods.");
    }
  };


  useEffect(() => {
    if (currentUser?.author?._id) {
      fetchPaymentMethods();
    }
  }, [currentUser]);

  // const fetchAndVerifyStripeAccount = async (stripeConnectId) => {
  //   try {
  //     const response = await backend.get(
  //       `/stripe-connect/verify/${stripeConnectId}`
  //     );
  //     if (response.status === 200) {
  //       console.log("Stripe account verification successful:", response.data);
  //       toast.success(response.data.message);
  //       fetchPaymentMethods();
  //       setIsVerified(true);
  //     }
  //   } catch (error) {
  //     console.error("Error verifying Stripe account:", error);
  //     toast.error("Failed to verify Stripe account.");
  //   }
  // };
  

  // const getStripeConnectIdFromPaymentMethods = () => {
  //   const bankAccountMethod = existingMethods.methods.find(
  //     (method) => method.receivingType === "bank_account"
  //   );

  //   console.log(bankAccountMethod?.stripeConnectId);
  //   return bankAccountMethod?.stripeConnectId || null;
  // };

  // const stripeConnectInstance = useStripeConnect(
  //   getStripeConnectIdFromPaymentMethods()
  // );

  // useEffect(() => {
  //   if (!isVerified) {
  //     const stripeConnectId = getStripeConnectIdFromPaymentMethods();

  //     if (stripeConnectId) {
  //       fetchAndVerifyStripeAccount(stripeConnectId);
  //     }
  //   }
  // }, [existingMethods, isVerified]);

  // useEffect(() => {
  //   const bankAccountMethod = existingMethods.methods.find(
  //     (method) => method.receivingType === "bank_account"
  //   );
  //   if (bankAccountMethod?.stripeConnectId) {
  //     setStripeConnectId(bankAccountMethod.stripeConnectId);
  //   }
  // }, [existingMethods]);

  const renderBankAccountTab = () => {
    return (
      <div className="container">
        <div className="content">
          {!connectedAccountId && (
            <Typography variant="h6">
              Start your journey with our payment platform
            </Typography>
          )}
          {connectedAccountId && !stripeConnectInstance && (
            <Typography variant="h6">
              Complete your account setup to start receiving payments
            </Typography>
          )}
          {!connectedAccountId && (
            <Button
              variant="contained"
              className={classes.submitBtn}
              onClick={async () => {
                setAccountCreatePending(true);
                try {
                  const response = await backend.post(
                    "/stripe-connect/account",
                    {
                      userId: currentUser?.author?._id,
                      receivingType: "bank_account",
                    }
                  );
  
                  const { account } = response.data;
                  if (account) {
                    setConnectedAccountId(account);
                    // setStripeConnectId(account);
                    toast.success("Stripe account created successfully!");
                  }
                } catch (err) {
                  console.error("Error creating account:", err);
                  toast.error("Failed to create Stripe account.");
                } finally {
                  setAccountCreatePending(false);
                }
              }}
            >
              {accountCreatePending ? "Creating Account..." : "Sign Up"}
            </Button>
          )}
          {stripeConnectInstance  && connectedAccountId && (
            <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
              <ConnectAccountOnboarding
              collectionOptions={{
                fields: "eventually_due",
                futureRequirements: "include",
              }}
                // onComplete={() => {
                //   toast.success("Onboarding completed successfully.");
                // }}
                onExit={() => {
                  setOnboardingExited(true);
                  // fetchAndVerifyStripeAccount(connectedAccountId);
                  toast.info("Onboarding process exited.");
                  history.push("/payment-integration");
                }}
              />
            </ConnectComponentsProvider>
          )}
        </div>
      </div>
    );
  };
  


  const saveAccount = async () => {
    if (isSaving) return;

    setIsSaving(true);
    try {
      if (!eMoneyAccountNo) {
        throw new Error("E-Money Account Number is required.");
      }
      const currentUrl = `${location.pathname}${location.search}`;

      const response = await backend.post("/payment-method", {
        user: currentUser.author._id,
        accountNo: eMoneyAccountNo,
        receivingType: "e_money",
        currentUrl
      });

      toast.success("E-Money account added successfully.");
      setExistingMethods((prev) => ({
        ...prev,
        methods: [
          ...prev.methods,
          { receivingType: "e_money", accountNo: eMoneyAccountNo },
        ],
      }));
      setEMoneyAccountNo("");
      history.push("/payment-integration");
    } catch (error) {
      console.error("Error saving E-Money account:", error);
      if (error.response && error.response.data) {
        const serverErrorMessage = error.response.data.error || "Unknown server error";
        toast.error(`${serverErrorMessage}`);
      }
    } finally {
      setIsSaving(false);
    }
  };


  return (
    <Fragment>
      <ToastContainer />
      <Helmet>
        <title>Manage Payment Methods - d2p</title>
      </Helmet>
      <PageBanner
        title="Add New Payment Method"
        image="/assets/images/bg4.jpg"
      />
      <Box style={{ width: "80%", maxWidth: 600, margin: "50px auto" }}>
        <Typography variant="h6" style={{ marginBottom: 20 }}>
          Add New Payment Method
        </Typography>
        {method === "bank_account" && renderBankAccountTab()}
        {method === "e_money" && (
          <Box>
            <InputLabel className={classes.fieldLabel}>
              E-Money Account Number
            </InputLabel>
            <TextField
              variant="outlined"
              className={classes.inputField}
              placeholder="Enter account number"
              value={eMoneyAccountNo}
              onChange={(e) => setEMoneyAccountNo(e.target.value)}
            />
            <Button
              variant="contained"
              className={classes.submitBtn}
              onClick={saveAccount}
            >
              Save
            </Button>
          </Box>
        )}
      </Box>
    </Fragment>
  );
};

AddNewPaymentMethod.propTypes = {
  register: PropTypes.func,
  redirect: PropTypes.func,
};

export default AddNewPaymentMethod;
